module.exports = __webpack_public_path__ + "static/media/ace_00001.ee33ad19.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/ace_00001.png
// module id = 23
// module chunks = 0